export const Tile = ({ children }) => {
    return (
        <div className='col-xs-8 col-sm-6 col-md-4 margin-top-15 margin-bottom-15'>
            {children}
        </div>
    );
};

export default Tile;
